import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { File64 } from 'app/helpers/components/sxFileImport/file64.interf';
import { ExternalComponentService } from 'app/infrastructure/services/externalComponent.service';
import { AzureFile } from 'app/infrastructure/model/interfaces/azureFile.Interface';
import { ExternalComponent } from 'app/infrastructure/model/classes/externalComponent.class';

@Component({
    selector: 'sx-external-component-edit',
    templateUrl: './edit.external-component.component.html',
})
export class ExternalComponentEditComponent implements OnInit {
    systemCode: string;
    alias: string;

    supportedPdb: string[] = ['.pdb'];
    supportedDll: string[] = ['.dll'];

    fileDll: File64 = null;
    filePdb: File64 = null;

    files: AzureFile[] = [];

    component: ExternalComponent = {
        alias: '',
        componentNamespace: '',
        systemCode: '',
        status: 'A',
    };

    disableAlias = false;

    constructor(private externalComponentService: ExternalComponentService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private alertService: AlertService,
        private translate: Translator) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {

            this.systemCode = params['codsistema'];
            this.alias = params['alias'];

            if (this.alias !== undefined && this.alias !== 'new') {
                this.externalComponentService.get(this.systemCode, this.alias).subscribe(c => {
                    this.component = c;
                    this.getFiles(this.alias);
                    this.disableAlias = true;
                });
            } else {
                this.component.systemCode = this.systemCode;
            }
        });
    }

    selectedDllFile(imp: File64) {
        this.fileDll = imp;
    }

    selectedPdbFile(imp: File64) {
        this.filePdb = imp;
    }

    save() {
        const request = {
            component: this.component,
            dllFileName: null,
            dllFile: null,
            pdbFileName: null,
            pdbFile: null,
        };

        if (this.fileDll !== null) {
            request.dllFileName = this.fileDll.fileName;
            request.dllFile = this.fileDll.fileData;
        }

        if (this.filePdb !== null) {
            request.pdbFileName = this.filePdb.fileName;
            request.pdbFile = this.filePdb.fileData;
        }

        this.externalComponentService.save(request).then(c => {
            this.alertService.showGrowl({
                type: GrowlType.SUCCESS,
                body: 'EXTERNAL_COMPONENT_SUCCESS',
            }, { alias: c.alias });

            this.back();
        });
    }

    isValidForm() {
        return this.component.alias
            && this.component.componentNamespace
            && this.component.alias !== 'new'
            && (this.files.length > 0 || (this.fileDll !== null && this.filePdb !== null));
    }

    getFiles(alias: string) {
        this.externalComponentService.getFiles(this.systemCode, alias).subscribe(f => this.files = f);
    }

    back() {
        this.router.navigate(['../'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/external-component/edit/edit.external-component.component.ts